module.exports = __webpack_public_path__ + "img/hr-splitter-north.7bc6879b.png";